import script from "./tank-config-list.vue?vue&type=script&setup=true&lang=js"
export * from "./tank-config-list.vue?vue&type=script&setup=true&lang=js"

import "./tank-config-list.vue?vue&type=style&index=0&id=65b161df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b161df"]])

export default __exports__